var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailIntensity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2526_19398)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2526_19398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 32.8308L12.8042 35.1317C13.5008 35.5533 14.3533 34.93 14.17 34.1417L13.1617 29.815L16.5258 26.9C17.14 26.3683 16.81 25.36 16.0033 25.2958L11.5758 24.92L9.84334 20.8317C9.53167 20.0892 8.46834 20.0892 8.15667 20.8317L6.42417 24.9108L1.99667 25.2867C1.19001 25.3508 0.860005 26.3592 1.47417 26.8908L4.83834 29.8058L3.83001 34.1325C3.64667 34.9208 4.49917 35.5442 5.19584 35.1225L9.00001 32.8308Z",
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2526_19398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 32.8308L34.8042 35.1317C35.5008 35.5533 36.3533 34.93 36.17 34.1417L35.1617 29.815L38.5258 26.9C39.14 26.3683 38.81 25.36 38.0033 25.2958L33.5758 24.92L31.8433 20.8317C31.5317 20.0892 30.4683 20.0892 30.1567 20.8317L28.4242 24.9108L23.9967 25.2867C23.19 25.3508 22.86 26.3592 23.4742 26.8908L26.8383 29.8058L25.83 34.1325C25.6467 34.9208 26.4992 35.5442 27.1958 35.1225L31 32.8308Z",
    fill: "#4F4F4F",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2526_19398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 14.8308L24.8042 17.1317C25.5008 17.5533 26.3533 16.93 26.17 16.1417L25.1617 11.815L28.5258 8.89999C29.14 8.36832 28.81 7.35999 28.0033 7.29582L23.5758 6.91999L21.8433 2.83166C21.5317 2.08916 20.4683 2.08916 20.1567 2.83166L18.4242 6.91082L13.9967 7.28666C13.19 7.35082 12.86 8.35916 13.4742 8.89082L16.8383 11.8058L15.83 16.1325C15.6467 16.9208 16.4992 17.5442 17.1958 17.1225L21 14.8308Z",
    fill: "#4F4F4F",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2526_19398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2526_19398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(-2 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2526_19398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(20 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2526_19398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(10 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIntensity);
export default __webpack_public_path__ + "static/media/detail-intensity.391603129c3de2a1bc437bdcec2e9ab1.svg";
export { ForwardRef as ReactComponent };